import { registerBlockType } from '@wordpress/blocks';
import Edit from './edit';
import metadata from './block.json';

import './components/assets/style.css';

const shopIcon = (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
    >
        <g clip-path="url(#clip0_10678_1684)">
            <path
                d="M7.625 8.75V6.875C7.65104 5.625 8.08073 4.59635 8.91406 3.78906C9.72135 2.95573 10.75 2.52604 12 2.5C13.25 2.52604 14.2786 2.95573 15.0859 3.78906C15.9193 4.59635 16.349 5.625 16.375 6.875V8.75H18.875C19.3958 8.77604 19.8385 8.95833 20.2031 9.29688C20.5417 9.66146 20.724 10.1042 20.75 10.625V18.75C20.724 19.8177 20.3594 20.7031 19.6562 21.4062C18.9531 22.1094 18.0677 22.474 17 22.5H7C5.93229 22.474 5.04688 22.1094 4.34375 21.4062C3.64062 20.7031 3.27604 19.8177 3.25 18.75V10.625C3.27604 10.1042 3.45833 9.66146 3.79688 9.29688C4.16146 8.95833 4.60417 8.77604 5.125 8.75H7.625ZM9.5 8.75H14.5V6.875C14.474 6.17188 14.2266 5.58594 13.7578 5.11719C13.2891 4.64844 12.7031 4.40104 12 4.375C11.2969 4.40104 10.7109 4.64844 10.2422 5.11719C9.77344 5.58594 9.52604 6.17188 9.5 6.875V8.75ZM5.125 10.625V18.75C5.15104 19.2708 5.33333 19.7135 5.67188 20.0781C6.03646 20.4167 6.47917 20.599 7 20.625H17C17.5208 20.599 17.9635 20.4167 18.3281 20.0781C18.6667 19.7135 18.849 19.2708 18.875 18.75V10.625H16.375V12.8125C16.3229 13.3854 16.0104 13.6979 15.4375 13.75C14.8646 13.6979 14.5521 13.3854 14.5 12.8125V10.625H9.5V12.8125C9.44792 13.3854 9.13542 13.6979 8.5625 13.75C7.98958 13.6979 7.67708 13.3854 7.625 12.8125V10.625H5.125Z"
                fill="#FF3C73"
            />
        </g>
        <defs>
            <clipPath id="clip0_10678_1684">
                <rect width="24" height="24" fill="white" />
            </clipPath>
        </defs>
    </svg>
);

registerBlockType(metadata.name, {
    icon: shopIcon,
    title: metadata.title,
    edit: Edit,
});
